<template>
  <div class="list-container">
    <div v-if="isMask" class="mask"></div>
    <Header
      @anchorScoll="scollTop"
      @showMask="toggleMask"
    />
    <div class="list">
      <div class="teads_here1"></div>     
      <h3 class="listTitle">{{ query }}</h3>
      <div class="content">
        <a
          v-for="item in list"
          :key="item.ID"
          class="newsBox"
          :href="`/detail/${item.ID}`"
        >
          <div class="newsImg">
            <img :src="item.meta_attached_file" alt="" />
          </div>
          <div class="labelBox">
            <a
              v-for="(val, index) in item.post_tag"
              :key="index"
              class="newsLabel"
              :href="`/list/tag/${(val || '').toLocaleLowerCase()}`"
              >#{{ val }}</a
            >
          </div>
          <div class="newsIntroduct">{{ item.post_title }}</div>
          <div class="newsContent">{{ item.post_excerpt }}</div>
          <div class="newsDate">{{ item.post_date }}</div>
        </a>
      </div>
      <Pagination
        :total="total"
        v-model="page"
        :pageSize="pageSize"
        @change="onPageSizeChange"
        :item-render="itemRender"
      />
      <div class="teads_here2"></div>
    </div>
    <Footer :isMobile="isMobile" @pageTop="pageTop" />
  </div>
</template>

<script>
import Pagination from "ant-design-vue/lib/pagination";
import Header from "@/views/components/header.vue";
import Banner from "@/views/components/banner.vue";
import Footer from "@/views/components/footer.vue";
import Mixin from "@/util/mixin";

import { fetchDataApi } from "@/api/common";

async function init(params) {
  const { code, data } = await fetchDataApi(params);
  if (code == 1511200) return data;
  return {};
}

export default {
  name: "List",
  mixins: [Mixin],
  components: {
    Header,
    Banner,
    Footer,
    Pagination,
  },
  data() {
    return {
      pageSize: 18,
      isMask: false,
    };
  },
  head() {
    const LANGUAGE_MAP = {
      english: {
        title: "HONEYEE.COM | WEB MAGAZINE",
        description: "HONEYEE.COM is a web magazine launched in 2005 for urban dwellers following cool fashion and culture, telling the stories of influential fashion brands and creators, as well as Japanese fashion culture internationally.",
      },
      japanese: {
        title: "HONEYEE.COM | WEB MAGAZINE",
        description: "クールなファッションやカルチャーを追いかけ続ける都市生活者に向けて2005年にスタートしたウェブマガジン。影響力のあるファッションブランドやクリエイターのストーリー、そして日本のファッション文化をグローバルに発信中。",
      },
      chinese: {
        title: "HONEYEE.COM | WEB MAGAZINE",
        description: "创立于2005年，以日本时尚文化为中心，以独立的视觉，带来众多新一代具有影响力的品牌与艺术家故事，面相全球时尚潮流爱好者。",
      },
    };
    return {
      title: LANGUAGE_MAP[process.env.WEB_SITE_LANGUAGE].title,
      mataInfo: `<meta name="description" content="${LANGUAGE_MAP[process.env.WEB_SITE_LANGUAGE].description}">`
    };
  },
  async asyncData({ route, store }) {
    const TYPE_MAP = {
      category: 0,
      tag: 1,
      search: 2,
    };

    let {
      params: { query, type },
      query: { page },
    } = route;

    let type2 = TYPE_MAP[type];
    store.commit("list/SET_QUERY", (query || "").toLocaleUpperCase());

    if (
      (type2 || type2 == 0) &&
      query !== undefined &&
      query !== "" &&
      query !== null
    ) {
      let params = {
        controller: "index",
        action: "list",
        type: type2,
        query,
        page: page || 1,
        page_size: 18,
      };

      const { list, categorys, count } = await init(params);            
      store.commit("list/SET_ASYNC_DATA", list);
      store.commit("list/SET_COUNT", count);
      store.commit("list/SET_PAGE", page || 1);
      store.commit("detail/SET_CATEGORYS", categorys);
    }
  },
  computed: {
    list() {
      return this.$store.state.list.asyncData;
    },
    query() {
      return this.$store.state.list.query;
    },
    total() {
      return Number(this.$store.state.list.count || 0);
    },
    page: {
      get() {
        return Number(this.$store.state.list.page || 1);
      },
      set(value) {
        this.$store.commit("list/SET_PAGE", value || 1);
      },
    },
  },
  methods: {
    toggleMask(flag) {
      this.isMask = flag;
    },
    itemRender(current, type, originalElement) {
      if (type === "prev") {
        return <a>PREV</a>;
      } else if (type === "next") {
        return <a>NEXT</a>;
      }
      return originalElement;
    },
    onPageSizeChange(page, size) {
      const { host, protocol, pathname } = location;
      location.href = `${protocol}//${host}${pathname}?page=${page}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.list-container {
  position: relative;
  width: 100%;
  .mask {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 99;
    background: rgba(10, 10, 10, 0.6);
  }
  .list {
    padding: 80px 7% 10% 140px;
    .listTitle {
      font-family: Helvetica;
      font-weight: bold;
      font-size: 58px;
      line-height: 67px;
      color: #232323;
      margin-bottom: 70px;
      margin-top: 70px;
    }
    .content {
      width: 100%;
      display: flex;
      // align-items: center;
      flex-wrap: wrap;
      margin-bottom: 60px;
      justify-content: space-between;
      .newsBox {
        width: 30%;
        margin-bottom: 60px;
        .newsImg {
          width: 100%;
          display: flex;
          align-items: center;
          cursor: pointer;
          overflow: hidden;
          display: flex;
          img {                          
            width: 100%;
            max-height: 100%;
          }
        }
        .labelBox {
          width: 100%;
          min-height: 80px;
          margin-top: 24px;
          .newsLabel {
            height: 26px;
            display: inline-block;
            background: #646464;
            border-radius: 2px;
            font-family: Helvetica;
            font-style: normal;
            font-weight: normal;
            font-size: 12px;
            line-height: 16px;
            color: #ffffff;
            padding: 5px 10px;
            margin: 0 12px 14px 0;
            cursor: pointer;
          }
        }
        .newsIntroduct {
          margin-bottom: 12px;
          font-family: Helvetica;
          font-size: 18px;
          line-height: 28px;
          color: #232323;
          width: 100%;
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          height: 56px;
        }
        .newsContent {
          font-family: Helvetica;
          font-size: 16px;
          line-height: 26px;
          letter-spacing: 0.05em;
          color: #787878;
          height: auto;
          overflow: hidden;
          word-break: break-all;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .newsDate {
          font-family: Helvetica;
          font-size: 12px;
          line-height: 20px;
          color: #787878;
        }
      }
    }
    ::v-deep.ant-pagination {
      width: 100%;
      text-align: center;
    }
    ::v-deep.ant-pagination-prev {
      float: left;
      height: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-prev a {
      font-family: Helvetica;
      font-size: 12px;
      line-height: 14px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #232323;
      height: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-next {
      float: right;
      height: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-next a {
      font-family: Helvetica;
      font-weight: 300;
      font-size: 12px;
      line-height: 14px;
      display: flex;
      align-items: center;
      text-align: center;
      color: #232323;
      height: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-item {
      height: 60px;
      min-width: 60px;
      border: 0;
      border-radius: 0;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-jump-prev {
      height: 60px;
      min-width: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-jump-next {
      height: 60px;
      min-width: 60px;
      line-height: 60px;
    }
    ::v-deep.ant-pagination-item-active {
      border-bottom: 1px solid #232323;
    }
  }
}
@media screen and (max-width: 1024px) {
  .list-container {
    .list {
      padding: 40 * $px 5% 10% 5%;
      .listTitle {
        font-family: Helvetica;
        font-weight: bold;
        font-size: 30 * $px;
        line-height: 34 * $px;
        color: #232323;
        margin-bottom: 20 * $px;
        margin-top: 20 * $px;
      }
      .content {
        width: 100%;
        .newsBox {
          width: 30%;
          margin-bottom: 30 * $px;
          .newsImg {
            width: 100%;
            max-height: 380px;
            display: flex;
            align-items: center;
            overflow: hidden;
            img {
              width: 100%;
              // max-height: 100%;
            }
          }
          .labelBox {
            width: 100%;
            min-height: 80px;
            margin-top: 24px;
            .newsLabel {
              height: 26px;
              display: inline-block;
              background: #646464;
              border-radius: 2px;
              font-family: Helvetica;
              font-style: normal;
              font-weight: normal;
              color: #ffffff;
              margin: 0 12px 14px 0;
            }
          }
          .newsIntroduct {
            margin-bottom: 12 * $px;
            font-family: Helvetica;
            color: #232323;
            max-height: 56 * $px;
            min-height: 28 * $px;
          }
          .newsContent {
            font-family: Helvetica;
            color: #787878;
            margin-bottom: 5 * $px;
          }
          .newsDate {
            font-family: Helvetica;
            font-size: 12px;
            line-height: 20px;
            color: #787878;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .list-container {
    .list {
      padding: 80 * $px 20 * $px 10% 20 * $px;
      .listTitle {
        font-family: Helvetica;
        font-weight: bold;
        font-size: 30 * $px;
        line-height: 34 * $px;
        color: #232323;
        margin-bottom: 20 * $px;
        margin-top: 20 * $px;
      }
      .content {
        width: 100%;
        display: block;
        .newsBox {
          width: 100%;
          margin-bottom: 30 * $px;
          border-bottom: 1px solid #efefef;
          .newsImg {
            width: 100%;
            height: 275 * $px;
            max-height: 275 * $px;
            display: flex;
            align-items: center;
            img {
              width: 100%;
              max-height: 100%;
            }
          }
          .newsDate {
            margin-bottom: 20 * $px;
          }
          .labelBox {
            width: 100%;
            min-height: 40px;
            margin-top: 0;
            .newsLabel {
              height: unset;
              display: inline-block;
              background: #646464;
              border-radius: 2px;
              font-family: Helvetica;
              font-style: normal;
              font-weight: normal;
              font-size: 12 * $px;
              line-height: 16 * $px;
              color: #ffffff;
              padding: 5 * $px 10 * $px;
              margin: 16 * $px 12 * $px 10 * $px 0;
            }
          }
        }
      }
      ::v-deep.ant-pagination-prev a {
        font-family: Helvetica;
        font-size: 12px;
        line-height: 14px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #232323;
        height: 35 * $px;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-next {
        float: right;
        height: 35 * $px;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-next a {
        font-family: Helvetica;
        font-weight: 300;
        font-size: 12px;
        line-height: 14px;
        display: flex;
        align-items: center;
        text-align: center;
        color: #232323;
        height: 35 * $px;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-item {
        height: 35 * $px;
        min-width: 35 * $px;
        border: 0;
        border-radius: 0;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-jump-prev {
        height: 35 * $px;
        min-width: 35 * $px;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-jump-next {
        display: none;
        height: 35 * $px;
        min-width: 35 * $px;
        line-height: 35 * $px;
      }
      ::v-deep.ant-pagination-item-active {
        border-bottom: 1px solid #232323;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// List.vue